import { forwardRef } from 'react';

import {
  type WithChildren,
  type DataTestId,
  type DOMProps,
  type StylingProps,
} from '@dynatrace/strato-components/core';
import { Flex } from '@dynatrace/strato-components/layouts';

//#region Typings
/**
 * @public
 */
export interface InformationOverlayIconProps
  extends DOMProps,
    WithChildren,
    DataTestId,
    StylingProps {}
//#endregion Typings

/**
 * The content of the InformationOverlay.
 * @public
 */
export const InformationOverlayIcon = forwardRef<
  HTMLDivElement,
  InformationOverlayIconProps
>((props, forwardedRef) => {
  const {
    children,
    className,
    style,
    'data-testid': dataTestId,
    ...remainingProps
  }: InformationOverlayIconProps = props;

  return (
    <Flex
      data-testid={dataTestId}
      ref={forwardedRef}
      className={className}
      style={style}
      {...remainingProps}
    >
      {children}
    </Flex>
  );
});

(
  InformationOverlayIcon as typeof InformationOverlayIcon & {
    displayName: string;
  }
).displayName = 'InformationOverlay.Icon';
